/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getUserVaccinationScheduleDetails } from 'app/entities/user-vaccination-schedule-details/user-vaccination-schedule-details.reducer';
import { getEntities as getPregnancyCases } from 'app/entities/pregnancy-case/pregnancy-case.reducer';
import { getEntities as getTrimesters } from 'app/entities/trimester/trimester.reducer';
import { createEntity, getEntity, reset, updateEntity } from './pregnancy-vaccine.reducer';

export const PregnancyVaccineUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const userVaccinationScheduleDetails = useAppSelector(state => state.userVaccinationScheduleDetails.entities);
  const pregnancyCases = useAppSelector(state => state.pregnancyCase.entities);
  const trimesters = useAppSelector(state => state.trimester.entities);
  const pregnancyVaccineEntity = useAppSelector(state => state.pregnancyVaccine.entity);
  const loading = useAppSelector(state => state.pregnancyVaccine.loading);
  const updating = useAppSelector(state => state.pregnancyVaccine.updating);
  const updateSuccess = useAppSelector(state => state.pregnancyVaccine.updateSuccess);

  const handleClose = () => {
    navigate(`/pregnancy-vaccine${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getUserVaccinationScheduleDetails({}));
    dispatch(getPregnancyCases({}));
    dispatch(getTrimesters({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...pregnancyVaccineEntity,
      ...values,
      vaccine: userVaccinationScheduleDetails.find(it => it.id.toString() === values.vaccine?.toString()),
      pregnancy: pregnancyCases.find(it => it.id.toString() === values.pregnancy?.toString()),
      trimester: trimesters.find(it => it.id.toString() === values.trimester?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...pregnancyVaccineEntity,
          vaccine: pregnancyVaccineEntity?.vaccine?.id,
          pregnancy: pregnancyVaccineEntity?.pregnancy?.id,
          trimester: pregnancyVaccineEntity?.trimester?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pregnancyVaccine.home.createOrEditLabel" data-cy="PregnancyVaccineCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pregnancyVaccine.home.createOrEditLabel">Create or edit a PregnancyVaccine</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pregnancy-vaccine-id"
                  label={translate('tinyMedicRestApp.pregnancyVaccine.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pregnancyVaccine.active')}
                id="pregnancy-vaccine-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pregnancyVaccine.draft')}
                id="pregnancy-vaccine-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pregnancyVaccine.cursor')}
                id="pregnancy-vaccine-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pregnancyVaccine.lastUpdated')}
                id="pregnancy-vaccine-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pregnancyVaccine.microSec')}
                id="pregnancy-vaccine-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pregnancyVaccine.timestampEntry')}
                id="pregnancy-vaccine-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="pregnancy-vaccine-vaccine"
                name="vaccine"
                data-cy="vaccine"
                label={translate('tinyMedicRestApp.pregnancyVaccine.vaccine')}
                type="select"
              >
                <option value="" key="0" />
                {userVaccinationScheduleDetails
                  ? userVaccinationScheduleDetails.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pregnancy-vaccine-pregnancy"
                name="pregnancy"
                data-cy="pregnancy"
                label={translate('tinyMedicRestApp.pregnancyVaccine.pregnancy')}
                type="select"
              >
                <option value="" key="0" />
                {pregnancyCases
                  ? pregnancyCases.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pregnancy-vaccine-trimester"
                name="trimester"
                data-cy="trimester"
                label={translate('tinyMedicRestApp.pregnancyVaccine.trimester')}
                type="select"
              >
                <option value="" key="0" />
                {trimesters
                  ? trimesters.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pregnancy-vaccine" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PregnancyVaccineUpdate;
